module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1264.9af9a1c3.png";